import {
  LIST_COMPANY_VEHICLES,
  LIST_COMPANY_VEHICLES_SUCCESS,
  LIST_COMPANY_VEHICLES_FAILURE,
  CREATE_COMPANY_VEHICLE,
  CREATE_COMPANY_VEHICLE_SUCCESS,
  CREATE_COMPANY_VEHICLE_FAILURE,
  UPDATE_COMPANY_VEHICLE,
  UPDATE_COMPANY_VEHICLE_SUCCESS,
  UPDATE_COMPANY_VEHICLE_FAILURE,
  DELETE_COMPANY_VEHICLE,
  DELETE_COMPANY_VEHICLE_SUCCESS,
  DELETE_COMPANY_VEHICLE_FAILURE,
  GET_COMPANY_VEHICLE_DETAILS,
  GET_COMPANY_VEHICLE_DETAILS_SUCCESS,
  GET_COMPANY_VEHICLE_DETAILS_FAILURE,
  COMPANY_VEHICLE_SEARCH,
  COMPANY_VEHICLE_SEARCH_SUCCESS,
  COMPANY_VEHICLE_SEARCH_FAILURE,
  COMPANY_VEHICLE_STATUS_LIST,
  COMPANY_VEHICLE_STATUS_LIST_SUCCESS,
  COMPANY_VEHICLE_STATUS_LIST_FAILURE,
  COMPANY_VEHICLE_STATUS_CREATE,
  COMPANY_VEHICLE_STATUS_CREATE_SUCCESS,
  COMPANY_VEHICLE_STATUS_CREATE_FAILURE,
  COMPANY_VEHICLE_STATUS_UPDATE,
  COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS,
  COMPANY_VEHICLE_STATUS_UPDATE_FAILURE,
  COMPANY_VEHICLE_STATUS_DELETE,
  COMPANY_VEHICLE_STATUS_DELETE_SUCCESS,
  COMPANY_VEHICLE_STATUS_DELETE_FAILURE,
  COMPANY_VEHICLE_TYPE_LIST,
  COMPANY_VEHICLE_TYPE_LIST_SUCCESS,
  COMPANY_VEHICLE_TYPE_LIST_FAILURE,
  COMPANY_VEHICLE_TYPE_CREATE,
  COMPANY_VEHICLE_TYPE_CREATE_SUCCESS,
  COMPANY_VEHICLE_TYPE_CREATE_FAILURE,
  COMPANY_VEHICLE_TYPE_UPDATE,
  COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_TYPE_UPDATE_FAILURE,
  COMPANY_VEHICLE_TYPE_DELETE,
  COMPANY_VEHICLE_TYPE_DELETE_SUCCESS,
  COMPANY_VEHICLE_TYPE_DELETE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_LIST,
  COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE,
  COMPANY_VEHICLE_CHECK_LIST,
  COMPANY_VEHICLE_CHECK_LIST_SUCCESS,
  COMPANY_VEHICLE_CHECK_LIST_FAILURE,
  COMPANY_VEHICLE_CHECK_CREATE,
  COMPANY_VEHICLE_CHECK_CREATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_CREATE_FAILURE,
  COMPANY_VEHICLE_CHECK_UPDATE,
  COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS,
  COMPANY_VEHICLE_CHECK_UPDATE_FAILURE,
  COMPANY_VEHICLE_CHECK_DELETE,
  COMPANY_VEHICLE_CHECK_DELETE_SUCCESS,
  COMPANY_VEHICLE_CHECK_DELETE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_LIST,
  COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_CREATE,
  COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_UPDATE,
  COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_DELETE,
  COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE,
  COMPANY_VEHICLE_TO_STAFF_SEARCH,
  COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS,
  COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE,
  COMPANY_VEHICLE_CHECKOUT,
  COMPANY_VEHICLE_CHECKOUT_SUCCESS,
  COMPANY_VEHICLE_CHECKOUT_FAILURE,
  COMPANY_VEHICLE_CHECKIN,
  COMPANY_VEHICLE_CHECKIN_SUCCESS,
  COMPANY_VEHICLE_CHECKIN_FAILURE,
  COMPANY_VEHICLE_NOTE_LIST,
  COMPANY_VEHICLE_NOTE_LIST_SUCCESS,
  COMPANY_VEHICLE_NOTE_LIST_FAILURE,
  COMPANY_VEHICLE_NOTE_CREATE,
  COMPANY_VEHICLE_NOTE_CREATE_SUCCESS,
  COMPANY_VEHICLE_NOTE_CREATE_FAILURE,
  COMPANY_VEHICLE_NOTE_UPDATE,
  COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS,
  COMPANY_VEHICLE_NOTE_UPDATE_FAILURE,
  COMPANY_VEHICLE_NOTE_DELETE,
  COMPANY_VEHICLE_NOTE_DELETE_SUCCESS,
  COMPANY_VEHICLE_NOTE_DELETE_FAILURE,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_LIST,
  COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE,
  COMPANY_VEHICLE_ATTACHMENT_DELETE,
  COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS,
  COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE,
} from "./actionType";

const initialValue = {
  companyVehicleList: [],
  companyVehicleListLoading: false,
  companyVehicleListError: null,

  companyVehicleDetails: [],
  companyVehicleDetailsLoading: false,
  companyVehicleDetailsError: null,

  companyVehicleCreate: [],
  companyVehicleCreateLoading: false,
  companyVehicleCreateError: null,

  companyVehicleUpdate: [],
  companyVehicleUpdateLoading: false,
  companyVehicleUpdateError: null,

  companyVehicleDelete: [],
  companyVehicleDeleteLoading: false,
  companyVehicleDeleteError: null,

  companyVehicleSearch: [],
  companyVehicleSearchLoading: false,
  companyVehicleSearchError: null,

  companyVehicleStatusList: [],
  companyVehicleStatusListLoading: false,
  companyVehicleStatusListError: null,

  companyVehicleStatusCreate: [],
  companyVehicleStatusCreateLoading: false,
  companyVehicleStatusCreateError: null,

  companyVehicleStatusUpdate: [],
  companyVehicleStatusUpdateLoading: false,
  companyVehicleStatusUpdateError: null,

  companyVehicleStatusDelete: [],
  companyVehicleStatusDeleteLoading: false,
  companyVehicleStatusDeleteError: null,

  companyVehicleTypeList: [],
  companyVehicleTypeListLoading: false,
  companyVehicleTypeListError: null,

  companyVehicleTypeCreate: [],
  companyVehicleTypeCreateLoading: false,
  companyVehicleTypeCreateError: null,

  companyVehicleTypeUpdate: [],
  companyVehicleTypeUpdateLoading: false,
  companyVehicleTypeUpdateError: null,

  companyVehicleTypeDelete: [],
  companyVehicleTypeDeleteLoading: false,
  companyVehicleTypeDeleteError: null,

  companyVehicleCheckTypeList: [],
  companyVehicleCheckTypeListLoading: false,
  companyVehicleCheckTypeListError: null,

  companyVehicleCheckTypeCreate: [],
  companyVehicleCheckTypeCreateLoading: false,
  companyVehicleCheckTypeCreateError: null,

  companyVehicleCheckTypeUpdate: [],
  companyVehicleCheckTypeUpdateLoading: false,
  companyVehicleCheckTypeUpdateError: null,

  companyVehicleCheckTypeDelete: [],
  companyVehicleCheckTypeDeleteLoading: false,
  companyVehicleCheckTypeDeleteError: null,

  companyVehicleCheckList: [],
  companyVehicleCheckListLoading: false,
  companyVehicleCheckListError: null,

  companyVehicleCheckCreate: [],
  companyVehicleCheckCreateLoading: false,
  companyVehicleCheckCreateError: null,

  companyVehicleCheckUpdate: [],
  companyVehicleCheckUpdateLoading: false,
  companyVehicleCheckUpdateError: null,

  companyVehicleCheckDelete: [],
  companyVehicleCheckDeleteLoading: false,
  companyVehicleCheckDeleteError: null,

  companyVehicleToStaffList: [],
  companyVehicleToStaffListLoading: false,
  companyVehicleToStaffListError: null,

  companyVehicleToStaffCreate: [],
  companyVehicleToStaffCreateLoading: false,
  companyVehicleToStaffCreateError: null,

  companyVehicleToStaffUpdate: [],
  companyVehicleToStaffUpdateLoading: false,
  companyVehicleToStaffUpdateError: null,

  companyVehicleToStaffDelete: [],
  companyVehicleToStaffDeleteLoading: false,
  companyVehicleToStaffDeleteError: null,

  companyVehicleToStaffSearch: [],
  companyVehicleToStaffSearchLoading: false,
  companyVehicleToStaffSearchError: null,

  companyVehicleCheckout: [],
  companyVehicleCheckoutLoading: false,
  companyVehicleCheckoutError: null,

  companyVehicleCheckin: [],
  companyVehicleCheckinLoading: false,
  companyVehicleCheckinError: null,

  companyVehicleNoteList: [],
  companyVehicleNoteListLoading: false,
  companyVehicleNoteListError: null,

  companyVehicleNoteCreate: [],
  companyVehicleNoteCreateLoading: false,
  companyVehicleNoteCreateError: null,

  companyVehicleNoteUpdate: [],
  companyVehicleNoteUpdateLoading: false,
  companyVehicleNoteUpdateError: null,

  companyVehicleNoteDelete: [],
  companyVehicleNoteDeleteLoading: false,
  companyVehicleNoteDeleteError: null,

  companyVehicleRecentActivityList: [],
  companyVehicleRecentActivityListLoading: false,
  companyVehicleRecentActivityListError: null,

  companyVehicleGpsTrackerList: [],
  companyVehicleGpsTrackerListLoading: false,
  companyVehicleGpsTrackerListError: null,

  companyVehicleGpsTrackerCreate: [],
  companyVehicleGpsTrackerCreateLoading: false,
  companyVehicleGpsTrackerCreateError: null,

  companyVehicleGpsTrackerUpdate: [],
  companyVehicleGpsTrackerUpdateLoading: false,
  companyVehicleGpsTrackerUpdateError: null,

  companyVehicleGpsTrackerDelete: [],
  companyVehicleGpsTrackerDeleteLoading: false,
  companyVehicleGpsTrackerDeleteError: null,

  gpsLiveDeviceList: [],
  gpsLiveDeviceListLoading: false,
  gpsLiveDeviceListError: null,

  companyVehicleGpsTrackerRefresh: [],
  companyVehicleGpsTrackerRefreshLoading: false,
  companyVehicleGpsTrackerRefreshError: null,

  companyVehicleAttachmentList: [],
  companyVehicleAttachmentListLoading: false,
  companyVehicleAttachmentListError: null,

  companyVehicleAttachmentDelete: [],
  companyVehicleAttachmentDeleteLoading: false,
  companyVehicleAttachmentDeleteError: null,
};

const CompanyVehicle = (state = initialValue, action) => {
  switch (action.type) {
    case LIST_COMPANY_VEHICLES:
      return {
        ...state,
        companyVehicleListLoading: true,
        companyVehicleListError: null,
      };
    case LIST_COMPANY_VEHICLES_SUCCESS:
      return {
        ...state,
        companyVehicleList: action.payload,
        companyVehicleListLoading: false,
        companyVehicleListError: null,
      };
    case LIST_COMPANY_VEHICLES_FAILURE:
      return {
        ...state,
        companyVehicleList: [],
        companyVehicleListLoading: false,
        companyVehicleListError: action.payload,
      };
    case CREATE_COMPANY_VEHICLE:
      return {
        ...state,
        companyVehicleCreateLoading: true,
        companyVehicleCreateError: null,
      };
    case CREATE_COMPANY_VEHICLE_SUCCESS:
      return {
        ...state,
        companyVehicleCreate: action.payload,
        companyVehicleCreateLoading: false,
        companyVehicleCreateError: null,
      };
    case CREATE_COMPANY_VEHICLE_FAILURE:
      return {
        ...state,
        companyVehicleCreate: [],
        companyVehicleCreateLoading: false,
        companyVehicleCreateError: action.payload,
      };
    case UPDATE_COMPANY_VEHICLE:
      return {
        ...state,
        companyVehicleUpdateLoading: true,
        companyVehicleUpdateError: null,
      };
    case UPDATE_COMPANY_VEHICLE_SUCCESS:
      return {
        ...state,
        companyVehicleUpdate: action.payload,
        companyVehicleUpdateLoading: false,
        companyVehicleUpdateError: null,
      };
    case UPDATE_COMPANY_VEHICLE_FAILURE:
      return {
        ...state,
        companyVehicleUpdate: [],
        companyVehicleUpdateLoading: false,
        companyVehicleUpdateError: action.payload,
      };
    case DELETE_COMPANY_VEHICLE:
      return {
        ...state,
        companyVehicleDeleteLoading: true,
        companyVehicleDeleteError: null,
      };
    case DELETE_COMPANY_VEHICLE_SUCCESS:
      return {
        ...state,
        companyVehicleDelete: action.payload,
        companyVehicleDeleteLoading: false,
        companyVehicleDeleteError: null,
      };
    case DELETE_COMPANY_VEHICLE_FAILURE:
      return {
        ...state,
        companyVehicleDelete: [],
        companyVehicleDeleteLoading: false,
        companyVehicleDeleteError: action.payload,
      };
    case GET_COMPANY_VEHICLE_DETAILS:
      return {
        ...state,
        companyVehicleDetailsLoading: true,
        companyVehicleDetailsError: null,
      };
    case GET_COMPANY_VEHICLE_DETAILS_SUCCESS:
      return {
        ...state,
        companyVehicleDetails: action.payload,
        companyVehicleDetailsLoading: false,
        companyVehicleDetailsError: null,
      };
    case GET_COMPANY_VEHICLE_DETAILS_FAILURE:
      return {
        ...state,
        companyVehicleDetails: [],
        companyVehicleDetailsLoading: false,
        companyVehicleDetailsError: action.payload,
      };
    case COMPANY_VEHICLE_SEARCH:
      return {
        ...state,
        companyVehicleSearchLoading: true,
        companyVehicleSearchError: null,
      };
    case COMPANY_VEHICLE_SEARCH_SUCCESS:
      return {
        ...state,
        companyVehicleSearch: action.payload,
        companyVehicleSearchLoading: false,
        companyVehicleSearchError: null,
      };
    case COMPANY_VEHICLE_SEARCH_FAILURE:
      return {
        ...state,
        companyVehicleSearch: [],
        companyVehicleSearchLoading: false,
        companyVehicleSearchError: action.payload,
      };
    case COMPANY_VEHICLE_STATUS_LIST:
      return {
        ...state,
        companyVehicleStatusListLoading: true,
        companyVehicleStatusListError: null,
      };
    case COMPANY_VEHICLE_STATUS_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleStatusList: action.payload,
        companyVehicleStatusListLoading: false,
        companyVehicleStatusListError: null,
      };
    case COMPANY_VEHICLE_STATUS_LIST_FAILURE:
      return {
        ...state,
        companyVehicleStatusList: [],
        companyVehicleStatusListLoading: false,
        companyVehicleStatusListError: action.payload,
      };
    case COMPANY_VEHICLE_STATUS_CREATE:
      return {
        ...state,
        companyVehicleStatusCreateLoading: true,
        companyVehicleStatusCreateError: null,
      };
    case COMPANY_VEHICLE_STATUS_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleStatusCreate: action.payload,
        companyVehicleStatusCreateLoading: false,
        companyVehicleStatusCreateError: null,
      };
    case COMPANY_VEHICLE_STATUS_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleStatusCreate: [],
        companyVehicleStatusCreateLoading: false,
        companyVehicleStatusCreateError: action.payload,
      };
    case COMPANY_VEHICLE_STATUS_UPDATE:
      return {
        ...state,
        companyVehicleStatusUpdateLoading: true,
        companyVehicleStatusUpdateError: null,
      };
    case COMPANY_VEHICLE_STATUS_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleStatusUpdate: action.payload,
        companyVehicleStatusUpdateLoading: false,
        companyVehicleStatusUpdateError: null,
      };
    case COMPANY_VEHICLE_STATUS_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleStatusUpdate: [],
        companyVehicleStatusUpdateLoading: false,
        companyVehicleStatusUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_STATUS_DELETE:
      return {
        ...state,
        companyVehicleStatusDeleteLoading: true,
        companyVehicleStatusDeleteError: null,
      };
    case COMPANY_VEHICLE_STATUS_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleStatusDelete: action.payload,
        companyVehicleStatusDeleteLoading: false,
        companyVehicleStatusDeleteError: null,
      };
    case COMPANY_VEHICLE_STATUS_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleStatusDelete: [],
        companyVehicleStatusDeleteLoading: false,
        companyVehicleStatusDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_TYPE_LIST:
      return {
        ...state,
        companyVehicleTypeListLoading: true,
        companyVehicleTypeListError: null,
      };
    case COMPANY_VEHICLE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleTypeList: action.payload,
        companyVehicleTypeListLoading: false,
        companyVehicleTypeListError: null,
      };
    case COMPANY_VEHICLE_TYPE_LIST_FAILURE:
      return {
        ...state,
        companyVehicleTypeList: [],
        companyVehicleTypeListLoading: false,
        companyVehicleTypeListError: action.payload,
      };
    case COMPANY_VEHICLE_TYPE_CREATE:
      return {
        ...state,
        companyVehicleTypeCreateLoading: true,
        companyVehicleTypeCreateError: null,
      };
    case COMPANY_VEHICLE_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleTypeCreate: action.payload,
        companyVehicleTypeCreateLoading: false,
        companyVehicleTypeCreateError: null,
      };
    case COMPANY_VEHICLE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleTypeCreate: [],
        companyVehicleTypeCreateLoading: false,
        companyVehicleTypeCreateError: action.payload,
      };
    case COMPANY_VEHICLE_TYPE_UPDATE:
      return {
        ...state,
        companyVehicleTypeUpdateLoading: true,
        companyVehicleTypeUpdateError: null,
      };
    case COMPANY_VEHICLE_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleTypeUpdate: action.payload,
        companyVehicleTypeUpdateLoading: false,
        companyVehicleTypeUpdateError: null,
      };
    case COMPANY_VEHICLE_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleTypeUpdate: [],
        companyVehicleTypeUpdateLoading: false,
        companyVehicleTypeUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_TYPE_DELETE:
      return {
        ...state,
        companyVehicleTypeDeleteLoading: true,
        companyVehicleTypeDeleteError: null,
      };
    case COMPANY_VEHICLE_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleTypeDelete: action.payload,
        companyVehicleTypeDeleteLoading: false,
        companyVehicleTypeDeleteError: null,
      };
    case COMPANY_VEHICLE_TYPE_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleTypeDelete: [],
        companyVehicleTypeDeleteLoading: false,
        companyVehicleTypeDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_LIST:
      return {
        ...state,
        companyVehicleCheckTypeListLoading: true,
        companyVehicleCheckTypeListError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleCheckTypeList: action.payload,
        companyVehicleCheckTypeListLoading: false,
        companyVehicleCheckTypeListError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_LIST_FAILURE:
      return {
        ...state,
        companyVehicleCheckTypeList: [],
        companyVehicleCheckTypeListLoading: false,
        companyVehicleCheckTypeListError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_CREATE:
      return {
        ...state,
        companyVehicleCheckTypeCreateLoading: true,
        companyVehicleCheckTypeCreateError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckTypeCreate: action.payload,
        companyVehicleCheckTypeCreateLoading: false,
        companyVehicleCheckTypeCreateError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleCheckTypeCreate: [],
        companyVehicleCheckTypeCreateLoading: false,
        companyVehicleCheckTypeCreateError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_UPDATE:
      return {
        ...state,
        companyVehicleCheckTypeUpdateLoading: true,
        companyVehicleCheckTypeUpdateError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckTypeUpdate: action.payload,
        companyVehicleCheckTypeUpdateLoading: false,
        companyVehicleCheckTypeUpdateError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleCheckTypeUpdate: [],
        companyVehicleCheckTypeUpdateLoading: false,
        companyVehicleCheckTypeUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_DELETE:
      return {
        ...state,
        companyVehicleCheckTypeDeleteLoading: true,
        companyVehicleCheckTypeDeleteError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckTypeDelete: action.payload,
        companyVehicleCheckTypeDeleteLoading: false,
        companyVehicleCheckTypeDeleteError: null,
      };
    case COMPANY_VEHICLE_CHECK_TYPE_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleCheckTypeDelete: [],
        companyVehicleCheckTypeDeleteLoading: false,
        companyVehicleCheckTypeDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_LIST:
      return {
        ...state,
        companyVehicleCheckListLoading: true,
        companyVehicleCheckListError: null,
      };
    case COMPANY_VEHICLE_CHECK_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleCheckList: action.payload,
        companyVehicleCheckListLoading: false,
        companyVehicleCheckListError: null,
      };
    case COMPANY_VEHICLE_CHECK_LIST_FAILURE:
      return {
        ...state,
        companyVehicleCheckList: [],
        companyVehicleCheckListLoading: false,
        companyVehicleCheckListError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_CREATE:
      return {
        ...state,
        companyVehicleCheckCreateLoading: true,
        companyVehicleCheckCreateError: null,
      };
    case COMPANY_VEHICLE_CHECK_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckCreate: action.payload,
        companyVehicleCheckCreateLoading: false,
        companyVehicleCheckCreateError: null,
      };
    case COMPANY_VEHICLE_CHECK_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleCheckCreate: [],
        companyVehicleCheckCreateLoading: false,
        companyVehicleCheckCreateError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_UPDATE:
      return {
        ...state,
        companyVehicleCheckUpdateLoading: true,
        companyVehicleCheckUpdateError: null,
      };
    case COMPANY_VEHICLE_CHECK_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckUpdate: action.payload,
        companyVehicleCheckUpdateLoading: false,
        companyVehicleCheckUpdateError: null,
      };
    case COMPANY_VEHICLE_CHECK_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleCheckUpdate: [],
        companyVehicleCheckUpdateLoading: false,
        companyVehicleCheckUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_CHECK_DELETE:
      return {
        ...state,
        companyVehicleCheckDeleteLoading: true,
        companyVehicleCheckDeleteError: null,
      };
    case COMPANY_VEHICLE_CHECK_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleCheckDelete: action.payload,
        companyVehicleCheckDeleteLoading: false,
        companyVehicleCheckDeleteError: null,
      };
    case COMPANY_VEHICLE_CHECK_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleCheckDelete: [],
        companyVehicleCheckDeleteLoading: false,
        companyVehicleCheckDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_TO_STAFF_LIST:
      return {
        ...state,
        companyVehicleToStaffListLoading: true,
        companyVehicleToStaffListError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleToStaffList: action.payload,
        companyVehicleToStaffListLoading: false,
        companyVehicleToStaffListError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_LIST_FAILURE:
      return {
        ...state,
        companyVehicleToStaffList: [],
        companyVehicleToStaffListLoading: false,
        companyVehicleToStaffListError: action.payload,
      };
    case COMPANY_VEHICLE_TO_STAFF_CREATE:
      return {
        ...state,
        companyVehicleToStaffCreateLoading: true,
        companyVehicleToStaffCreateError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleToStaffCreate: action.payload,
        companyVehicleToStaffCreateLoading: false,
        companyVehicleToStaffCreateError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleToStaffCreate: [],
        companyVehicleToStaffCreateLoading: false,
        companyVehicleToStaffCreateError: action.payload,
      };
    case COMPANY_VEHICLE_TO_STAFF_UPDATE:
      return {
        ...state,
        companyVehicleToStaffUpdateLoading: true,
        companyVehicleToStaffUpdateError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleToStaffUpdate: action.payload,
        companyVehicleToStaffUpdateLoading: false,
        companyVehicleToStaffUpdateError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleToStaffUpdate: [],
        companyVehicleToStaffUpdateLoading: false,
        companyVehicleToStaffUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_TO_STAFF_DELETE:
      return {
        ...state,
        companyVehicleToStaffDeleteLoading: true,
        companyVehicleToStaffDeleteError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleToStaffDelete: action.payload,
        companyVehicleToStaffDeleteLoading: false,
        companyVehicleToStaffDeleteError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleToStaffDelete: [],
        companyVehicleToStaffDeleteLoading: false,
        companyVehicleToStaffDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_TO_STAFF_SEARCH:
      return {
        ...state,
        companyVehicleToStaffSearchLoading: true,
        companyVehicleToStaffSearchError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_SEARCH_SUCCESS:
      return {
        ...state,
        companyVehicleToStaffSearch: action.payload,
        companyVehicleToStaffSearchLoading: false,
        companyVehicleToStaffSearchError: null,
      };
    case COMPANY_VEHICLE_TO_STAFF_SEARCH_FAILURE:
      return {
        ...state,
        companyVehicleToStaffSearch: [],
        companyVehicleToStaffSearchLoading: false,
        companyVehicleToStaffSearchError: action.payload,
      };
    case COMPANY_VEHICLE_CHECKOUT:
      return {
        ...state,
        companyVehicleCheckoutLoading: true,
        companyVehicleCheckoutError: null,
      };
    case COMPANY_VEHICLE_CHECKOUT_SUCCESS:
      return {
        ...state,
        companyVehicleCheckout: action.payload,
        companyVehicleCheckoutLoading: false,
        companyVehicleCheckoutError: null,
      };
    case COMPANY_VEHICLE_CHECKOUT_FAILURE:
      return {
        ...state,
        companyVehicleCheckout: [],
        companyVehicleCheckoutLoading: false,
        companyVehicleCheckoutError: action.payload,
      };
    case COMPANY_VEHICLE_CHECKIN:
      return {
        ...state,
        companyVehicleCheckinLoading: true,
        companyVehicleCheckinError: null,
      };
    case COMPANY_VEHICLE_CHECKIN_SUCCESS:
      return {
        ...state,
        companyVehicleCheckin: action.payload,
        companyVehicleCheckinLoading: false,
        companyVehicleCheckinError: null,
      };
    case COMPANY_VEHICLE_CHECKIN_FAILURE:
      return {
        ...state,
        companyVehicleCheckin: [],
        companyVehicleCheckinLoading: false,
        companyVehicleCheckinError: action.payload,
      };
    case COMPANY_VEHICLE_NOTE_LIST:
      return {
        ...state,
        companyVehicleNoteListLoading: true,
        companyVehicleNoteListError: null,
      };
    case COMPANY_VEHICLE_NOTE_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleNoteList: action.payload,
        companyVehicleNoteListLoading: false,
        companyVehicleNoteListError: null,
      };
    case COMPANY_VEHICLE_NOTE_LIST_FAILURE:
      return {
        ...state,
        companyVehicleNoteList: [],
        companyVehicleNoteListLoading: false,
        companyVehicleNoteListError: action.payload,
      };
    case COMPANY_VEHICLE_NOTE_CREATE:
      return {
        ...state,
        companyVehicleNoteCreateLoading: true,
        companyVehicleNoteCreateError: null,
      };
    case COMPANY_VEHICLE_NOTE_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleNoteCreate: action.payload,
        companyVehicleNoteCreateLoading: false,
        companyVehicleNoteCreateError: null,
      };
    case COMPANY_VEHICLE_NOTE_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleNoteCreate: [],
        companyVehicleNoteCreateLoading: false,
        companyVehicleNoteCreateError: action.payload,
      };
    case COMPANY_VEHICLE_NOTE_UPDATE:
      return {
        ...state,
        companyVehicleNoteUpdateLoading: true,
        companyVehicleNoteUpdateError: null,
      };
    case COMPANY_VEHICLE_NOTE_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleNoteUpdate: action.payload,
        companyVehicleNoteUpdateLoading: false,
        companyVehicleNoteUpdateError: null,
      };
    case COMPANY_VEHICLE_NOTE_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleNoteUpdate: [],
        companyVehicleNoteUpdateLoading: false,
        companyVehicleNoteUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_NOTE_DELETE:
      return {
        ...state,
        companyVehicleNoteDeleteLoading: true,
        companyVehicleNoteDeleteError: null,
      };
    case COMPANY_VEHICLE_NOTE_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleNoteDelete: action.payload,
        companyVehicleNoteDeleteLoading: false,
        companyVehicleNoteDeleteError: null,
      };
    case COMPANY_VEHICLE_NOTE_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleNoteDelete: [],
        companyVehicleNoteDeleteLoading: false,
        companyVehicleNoteDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        companyVehicleRecentActivityListLoading: true,
        companyVehicleRecentActivityListError: null,
      };
    case COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleRecentActivityList: action.payload,
        companyVehicleRecentActivityListLoading: false,
        companyVehicleRecentActivityListError: null,
      };
    case COMPANY_VEHICLE_RECENT_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        companyVehicleRecentActivityList: [],
        companyVehicleRecentActivityListLoading: false,
        companyVehicleRecentActivityListError: action.payload,
      };

    // ---- CompanyVehicleGpsTracker ----
    case COMPANY_VEHICLE_GPS_TRACKER_LIST:
      return {
        ...state,
        companyVehicleGpsTrackerListLoading: true,
        companyVehicleGpsTrackerListError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_LIST_SUCCESS:
      return {
        ...state,
        companyVehicleGpsTrackerList: action.payload,
        companyVehicleGpsTrackerListLoading: false,
        companyVehicleGpsTrackerListError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_LIST_FAILURE:
      return {
        ...state,
        companyVehicleGpsTrackerList: [],
        companyVehicleGpsTrackerListLoading: false,
        companyVehicleGpsTrackerListError: action.payload,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_CREATE:
      return {
        ...state,
        companyVehicleGpsTrackerCreateLoading: true,
        companyVehicleGpsTrackerCreateError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_CREATE_SUCCESS:
      return {
        ...state,
        companyVehicleGpsTrackerCreate: action.payload,
        companyVehicleGpsTrackerCreateLoading: false,
        companyVehicleGpsTrackerCreateError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_CREATE_FAILURE:
      return {
        ...state,
        companyVehicleGpsTrackerCreate: [],
        companyVehicleGpsTrackerCreateLoading: false,
        companyVehicleGpsTrackerCreateError: action.payload,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_UPDATE:
      return {
        ...state,
        companyVehicleGpsTrackerUpdateLoading: true,
        companyVehicleGpsTrackerUpdateError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_UPDATE_SUCCESS:
      return {
        ...state,
        companyVehicleGpsTrackerUpdate: action.payload,
        companyVehicleGpsTrackerUpdateLoading: false,
        companyVehicleGpsTrackerUpdateError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_UPDATE_FAILURE:
      return {
        ...state,
        companyVehicleGpsTrackerUpdate: [],
        companyVehicleGpsTrackerUpdateLoading: false,
        companyVehicleGpsTrackerUpdateError: action.payload,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_DELETE:
      return {
        ...state,
        companyVehicleGpsTrackerDeleteLoading: true,
        companyVehicleGpsTrackerDeleteError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleGpsTrackerDelete: action.payload,
        companyVehicleGpsTrackerDeleteLoading: false,
        companyVehicleGpsTrackerDeleteError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleGpsTrackerDelete: [],
        companyVehicleGpsTrackerDeleteLoading: false,
        companyVehicleGpsTrackerDeleteError: action.payload,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES:
      return {
        ...state,
        gpsLiveDeviceListLoading: true,
        gpsLiveDeviceListError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_SUCCESS:
      return {
        ...state,
        gpsLiveDeviceList: action.payload,
        gpsLiveDeviceListLoading: false,
        gpsLiveDeviceListError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES_FAILURE:
      return {
        ...state,
        gpsLiveDeviceList: [],
        gpsLiveDeviceListLoading: false,
        gpsLiveDeviceListError: action.payload,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_REFRESH:
      return {
        ...state,
        companyVehicleGpsTrackerRefreshLoading: true,
        companyVehicleGpsTrackerRefreshError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_REFRESH_SUCCESS:
      return {
        ...state,
        companyVehicleGpsTrackerRefresh: action.payload,
        companyVehicleGpsTrackerRefreshLoading: false,
        companyVehicleGpsTrackerRefreshError: null,
      };
    case COMPANY_VEHICLE_GPS_TRACKER_REFRESH_FAILURE:
      return {
        ...state,
        companyVehicleGpsTrackerRefresh: [],
        companyVehicleGpsTrackerRefreshLoading: false,
        companyVehicleGpsTrackerRefreshError: action.payload,
      };

    // ---- CompanyVehicleAttachment ----
    case COMPANY_VEHICLE_ATTACHMENT_SEARCH:
      return {
        ...state,
        companyVehicleAttachmentListLoading: true,
        companyVehicleAttachmentListError: null,
      };
    case COMPANY_VEHICLE_ATTACHMENT_SEARCH_SUCCESS:
      return {
        ...state,
        companyVehicleAttachmentList: action.payload,
        companyVehicleAttachmentListLoading: false,
        companyVehicleAttachmentListError: null,
      };
    case COMPANY_VEHICLE_ATTACHMENT_SEARCH_FAILURE:
      return {
        ...state,
        companyVehicleAttachmentList: [],
        companyVehicleAttachmentListLoading: false,
        companyVehicleAttachmentListError: action.payload,
      };
    case COMPANY_VEHICLE_ATTACHMENT_DELETE:
      return {
        ...state,
        companyVehicleAttachmentDeleteLoading: true,
        companyVehicleAttachmentDeleteError: null,
      };
    case COMPANY_VEHICLE_ATTACHMENT_DELETE_SUCCESS:
      return {
        ...state,
        companyVehicleAttachmentDelete: action.payload,
        companyVehicleAttachmentDeleteLoading: false,
        companyVehicleAttachmentDeleteError: null,
      };
    case COMPANY_VEHICLE_ATTACHMENT_DELETE_FAILURE:
      return {
        ...state,
        companyVehicleAttachmentDelete: [],
        companyVehicleAttachmentDeleteLoading: false,
        companyVehicleAttachmentDeleteError: action.payload,
      };

    default:
      return state;
  }
};

export default CompanyVehicle;
